<script>
	import Select, { Option } from "@smui/select";
	import { Icon } from "@smui/common";

	import { fontthemes } from "../stores";

	export let selected;
	export let modified;
	export let original;
	export let noSelection = false;
	export let noSelectionLabel = "";
	export let label = "Select font theme";

	$: modified = selected != original; // using != (without second =) on purpose because null === undefined is false and null == undefined is true which is what we need
</script>

<div class="edit-fonttheme">
	<Select bind:value={selected} {label} key={(value) => `${value == null ? noSelectionLabel : value}`}>
		{#if noSelection}
			<Option value={null}>{noSelectionLabel}</Option>
		{/if}
		{#each $fontthemes.sort((a, b) => b.free - a.free) as ft (ft.fonttheme_id)}
			<Option value={ft.fonttheme_id}>
				{ft.name}
				{#if !ft.free}
					<Icon class="material-icons select">paid</Icon>
				{/if}
			</Option>
		{/each}
		<svelte:fragment slot="helperText">
			<Icon class="material-icons helpertext">paid</Icon>
			Paid font themes. All others are free to use.
		</svelte:fragment>
	</Select>
</div>

<style lang="scss">
	.edit-fonttheme {
		:global(.mdc-select) {
			width: 100%;
			max-width: 400px;
		}

		:global(.select.material-icons) {
			margin-left: 10px;
			font-size: 1.5em;
			vertical-align: bottom;
		}

		:global(.helpertext.material-icons) {
			margin-right: 3px;
			font-size: 1.5em;
			vertical-align: bottom;
		}

		:global(.mdc-select__menu) {
			max-height: 400px !important;
		}
	}
</style>
